<script setup lang="ts">
import CartItemDeleteButton from './CartItemDeleteButton.vue';

defineProps<{
  disabled: boolean;
}>();

const emit = defineEmits<{
  delete: [];
}>();
</script>

<template>
  <div class="error-state" role="alert">
    <svg
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      />
    </svg>
    <div class="error-content">
      <p class="error-title">
        {{ $t('cart.details.errorLoadTitle') }}
      </p>
      <p class="error-description">
        {{ $t('cart.details.errorLoadDescription') }}
      </p>
    </div>
    <CartItemDeleteButton
      class="error-delete"
      :is-deleting="false"
      :disabled="disabled"
      @delete="emit('delete')"
    />
  </div>
</template>

<style scoped lang="css">
.error-state {
  display: flex;
  align-items: center;
  gap: var(--yb-spacing-sm);
  padding: var(--yb-spacing-sm);
  background: #fef2f2;
  border-radius: var(--yb-radius-sm);
  color: #dc2626;

  > svg {
    flex-shrink: 0;
  }
}

.error-delete {
  margin-left: auto;
  color: var(--yb-color-black);
}

.error-content {
  flex: 1;
  min-width: 0;
}

.error-title {
  font-weight: var(--yb-text-semi-bold);
  color: #dc2626;
  margin: 0;
}

.error-description {
  font-size: var(--yb-text-sm);
  color: #991b1b;
  margin: var(--yb-spacing-xs) 0 0 0;
}
</style>
